import React from "react";
import Logo from "../Logo";
import styles from './Footer.module.css'
import { Link } from "react-router-dom";
import { FacebookOutlined, Instagram, LinkedIn, Twitter, YouTube } from "@mui/icons-material";

function Footer() {
  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.footer_row}>
            <div className={styles.footer_col}>
              <Logo />
              <h4>PRIMARY DEALER</h4>
              <ul>
                <li><Link>Dealer One</Link></li>
                <li><p>+44 345 111 0002</p></li>
                <li ><Link className="text-lowercase">info@dealerone.com</Link></li>
                <li>
                  <p>4th Floor, 1 Tony Wilson Place, Manchester, M15 4FN, United Kingdom</p>
                </li>
                <li>
                  <p>Hours of Operation </p>
                  <p>Mon - Fri: 9AM - 6PM </p>

                  <p>Sat: 10AM - 5PM</p>
                  {/* <p>Sun: 10AM - 5PM</p> */}
                </li>
                <li><Link ><span className="text-lowercase">www.dealerone.io</span> </Link></li>
              </ul>
              <div className={styles.social_links}>
                <Link><i className={styles.brands}><FacebookOutlined /></i></Link>
                <Link><i className={styles.brands}><Twitter /></i></Link>
                <Link><i className={styles.brands}><Instagram /></i></Link>
                <Link><i className={styles.brands}><YouTube /></i></Link>
                <Link><i className={styles.brands}><LinkedIn /></i></Link>
              </div>
            </div>

            <div className={styles.footer_col}>
              <h4>CONTACT</h4>
              <ul>
                <li><Link>Contact us</Link></li>
                <li><Link>Find A Dealership</Link></li>

              </ul>
            </div>
            <div className={styles.footer_col}>
              <h4>QUICK LINKS</h4>
              <ul>
                <li><Link>Book a test drive</Link></li>
                <li><Link>Download a brochure</Link></li>

                <li><Link>Book a Service</Link></li>

                {/* <li><Link>Lucid Shop</Link></li> */}

              </ul>
            </div>
            <div className={styles.footer_col}>
              <h4>EXPERIENCE LANE</h4>
              <ul>
                <li><Link>About us</Link></li>

                <li><Link>Careers</Link></li>
              </ul>
            </div>
            <div className={styles.footer_col}>
              <h4>LEGAL</h4>
              <ul>
                <li><Link>Legal Information</Link></li>

                <li><Link>Product Safety Enquiry</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className={styles.footer_bottom}>
        <div className={styles.container}>
          <div className={styles.footerlabel}>
            <div className={styles.footleft}>
              <p>(C) AutoTrader 2024</p>
            </div>
            <div className={styles.footright}>
              <ul>
                <li><Link>Legal Notice</Link></li>
                <li><Link>Privacy Policy</Link></li>
                <li><Link>Cookie Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer;